import moment from 'moment-timezone';
import { MIAMI_TZ, parseDateInMiamiTZ } from './parseDateInMiamiTZ';

export const daysOverdueFromDueDate = dueDate => {
  const due = parseDateInMiamiTZ(dueDate);
  if (!due) return 0;
  const today = moment().tz(MIAMI_TZ).startOf('day');
  const dueMoment = moment(due).tz(MIAMI_TZ).startOf('day');
  return Math.max(0, today.diff(dueMoment, 'days'));
};

export const isPastDueUnpaidInvoice = row =>
  row?.status !== 'Paid' && daysOverdueFromDueDate(row?.invoiceDueDate) > 0;

export const getPastDueUnpaidInvoices = (invoices = []) =>
  (Array.isArray(invoices) ? invoices : []).filter(isPastDueUnpaidInvoice).map(row => ({
    ...row,
    daysOverdue: daysOverdueFromDueDate(row.invoiceDueDate)
  }));
